<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">统计分析管理&nbsp;/&nbsp;</div>
        <div class="box-header-left-text">
          <div>巡查记录比对分析&nbsp;/&nbsp;</div>
        </div>
        <div class="box-header-right" v-if="activeName == 'first'">
          <div>按部门</div>
        </div>
        <div class="box-header-right" v-if="activeName == 'second'">
          <div>按角色</div>
        </div>
      </div>
    </div>
    <div class="ledger">
      <el-tabs v-model="activeName">
        <el-tab-pane label="按部门" name="first">
          <list v-if="activeName == 'first'"></list>
        </el-tab-pane>
        <el-tab-pane label="按角色" name="second">
          <list2 v-if="activeName == 'second'"></list2>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import list from "./list.vue";
import list2 from "./list2.vue";

export default {
  name: "index",
  components: {
    list,
    list2
  },
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.ledger {
  background: #fff;
  padding: 16px 20px;
  height: calc(100% - 60px);
  .el-tabs {
    background: #fff;
  }
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/comparisonInspectionRecords/index.vue